/**
 * メディアクエリユーティリティクラス
 *
 * 画面サイズとピクセル密度に基づいたメディアクエリ文字列を提供します。
 * コンポーネント間で一貫したメディアクエリを使用するために使用します。
 */
class MediaQueryUtilityClass {
  /**
   * 事前定義されたメディアクエリ文字列
   *
   * モバイル: 767px以下の画面サイズ
   * デスクトップ: 768px以上の画面サイズ
   *
   * 解像度:
   * - normal: 標準解像度 (1x)
   * - @2x: 高解像度 (2x)
   * - @3x: 超高解像度 (3x)
   */
  private readonly mediaQueries = {
    // モバイル用クエリ
    sp: {
      normal: '(max-width: 767px)',
      '@2x':
        '(max-width: 767px) and (min-resolution: 2dppx), (max-width: 767px) and (-webkit-min-device-pixel-ratio: 2)',
      '@3x':
        '(max-width: 767px) and (min-resolution: 3dppx), (max-width: 767px) and (-webkit-min-device-pixel-ratio: 3)',
    },
    // デスクトップ用クエリ
    pc: {
      normal: '(min-width: 768px)',
      '@2x':
        '(min-width: 768px) and (min-resolution: 2dppx), (min-width: 768px) and (-webkit-min-device-pixel-ratio: 2)',
      '@3x':
        '(min-width: 768px) and (min-resolution: 3dppx), (min-width: 768px) and (-webkit-min-device-pixel-ratio: 3)',
    },
  };

  /**
   * メディアクエリを取得するメソッド
   *
   * @param deviceType - デバイスタイプ ('sp' または 'pc')
   * @param resolution - 解像度タイプ ('normal', '@2x', または '@3x')、省略時は 'normal'
   * @returns メディアクエリ文字列
   *
   * @example
   * // モバイルの標準解像度用メディアクエリを取得
   * const query = MediaQueryUtility.getMediaQuery('sp');
   *
   * @example
   * // デスクトップの高解像度(2x)用メディアクエリを取得
   * const query = MediaQueryUtility.getMediaQuery('pc', '@2x');
   */
  getMediaQuery(deviceType: 'sp' | 'pc', resolution?: 'normal' | '@2x' | '@3x'): string {
    // 解像度が指定されていない場合は標準解像度を使用
    const res = resolution || 'normal';
    return this.mediaQueries[deviceType][res];
  }
}

const MediaQueryUtility = new MediaQueryUtilityClass();
export default MediaQueryUtility;
